import React from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES, type Language } from "./i18n";

const LABELS: Record<Language, string> = { en: "EN", fr: "FR" };

/**
 * Compact EN / FR segmented switch. The choice is persisted to localStorage by
 * i18next-browser-languagedetector, so it sticks for every user on this browser.
 */
const LanguageToggle: React.FC<{ className?: string }> = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const current = (SUPPORTED_LANGUAGES.find((l) => i18n.language?.startsWith(l)) || "en") as Language;

  return (
    <div className={`inline-flex rounded-full border border-gray-300 overflow-hidden text-xs font-semibold ${className}`}>
      {SUPPORTED_LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          aria-pressed={current === lng}
          onClick={() => i18n.changeLanguage(lng)}
          className={`px-2.5 py-1 transition ${
            current === lng ? "bg-teal-600 text-white" : "bg-white text-gray-600 hover:bg-gray-100"
          }`}
        >
          {LABELS[lng]}
        </button>
      ))}
    </div>
  );
};

export default LanguageToggle;
